import * as React from 'react'
import { Flex, Box, Text, Button } from 'components/ds'
import Logo from 'components/ui/logo'
import 'components/error-page/index.css'
import styles from './index.module.css'
import cn from 'clsx'

export const BriefNotFound = () => {
  return (
    <Box className={cn('ErrorPage_Block', styles.background)} minHeight="500px">
      <Flex align="center" direction="column">
        <h1>
          <Text size="7" color="gray" highContrast>
            Sorry! This brief is no longer available
          </Text>
        </h1>

        <Box maxWidth="454px">
          <Text
            weight="medium"
            size="3"
            as="p"
            align="center"
            color="gray"
            highContrast
          >
            It looks like the brief you’re trying to access has been closed,
            removed, or doesn’t exist anymore.
          </Text>
        </Box>
        <a href="https://www.disco.ac/">
          <Button mt="5">Go to home page</Button>
        </a>
      </Flex>
      <Box position="absolute" bottom="32px">
        <Logo variant="dark" />
      </Box>
    </Box>
  )
}
